/*
	Fecha o Popper Global
*/
export default (state, { removeComponentTimeout }) => {
	clearTimeout(state.Popper.removeComponentTimeout)
	state.Popper.show = false
	state.Popper.removeComponentTimeout = removeComponentTimeout
}
	
